import { render, staticRenderFns } from "./body-sections.vue?vue&type=template&id=48911bf6&"
import script from "./body-sections.vue?vue&type=script&lang=js&"
export * from "./body-sections.vue?vue&type=script&lang=js&"
import style0 from "./body-sections.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports